<template>
    <div>
        <template v-if="filterTime">
            <!--分时段：不展示内容-->
        </template>
        <p v-else class="pl10 pr10 relative pt2 pb2">
            <el-checkbox v-model="field.checked" :disabled="field.disabled||filterTime||compareSumField" :key="filterType+field.display_name" @change="changeCheckbox(field,$event)">
                <template v-if="field.config.title">
                    <span>{{field.display_name}}</span>
                    <el-tooltip class="item" effect="dark" :content="field.config.title" placement="top">
                        <i class="el-icon-question pointer ml4 text-color-normal" ></i>
                    </el-tooltip>
                </template>
                <span v-else>{{field.display_name}}</span>
            </el-checkbox>

            <span class="menu-btn pointer absolute" :class="isActiveMenu?'active':''" v-if="!hideMenu&&!field.disabled" @click="handleMenuClick(field)" style="right: 10px;">
            <i class="el-icon-menu"></i>
        </span>
        </p>
    </div>

</template>

<script>
    export default {
        name: "CheckItem",
        props:{
            field:{
                required: true,
                type:Object,
            },
            hideMenu:{
                required: false,
                type:Boolean,
                default:false,
            },
            filterType:{
                type:String,
            },
            isActiveMenu:{
                required: false,
                type:Boolean,
                default:false,
            },
            isTimeFilter:{
                required: false,
                type:Boolean,
                default:false,
            },
            isCompare:{
                required: false,
                type:Boolean,
                default:false,
            },
            isSumField:{
                required: false,
                type:Boolean,
                default:false,
            }
        },
        computed:{
            filterTime(){
                if(this.isTimeFilter){
                    let config = this.field.config||{};
                    return !(config.time_type||[]).includes('hour');
                }else{
                    return false;
                }
            },
            compareSumField(){
                return this.isCompare&&this.isSumField;
            },
        },
        methods:{
            handleMenuClick(field){
                this.$emit('click-menu',field);
            },
            changeCheckbox(field,val){
                this.$emit('change',field,val,this.filterType);
            },

        }
    }
</script>

<style lang="scss" scoped>

    .split-bar{
        position: absolute;
        right: -4px;
        top:calc(50% - 100px);
        width: 8px;
        height: 200px;
        background: #fff;
        border: solid 1px #ccc;
        border-radius: 4px;
        cursor: pointer;
        &.direction-up,&.direction-down{
            width: 200px;
            height: 8px;
            bottom: -4px;
            left:calc(50% - 100px);
            top: auto;
            .arrow-icon{
                transform: scale(2,0.5) translate(45px,-8px);
            }
        }
        .arrow-icon{
            transform: scale(0.5,2) translate(-6px,45px);
            color: #666;
        }
        &:hover{
            border: solid 1px #aaa;
            color: #333!important;
        }
    }

    .menu-btn.active,.menu-btn:hover{
        color: #409EFF;
    }
</style>
